<template>
  <div>
    <v-card class="ma-1">
      <v-row class="ma-0">
        <!-- Course Thumbnail -->
        <v-col cols="3">
          <v-img
            width="100%"
            height="170"
            style="border-radius: 0.5rem"
            :src="course.thumbnail"
          ></v-img>
        </v-col>

        <!-- Course Details -->
        <v-col cols="6">
          <v-card-title class="ma-1 pa-0">
            <span v-if="course.courseName.length <= 50">{{
              course.courseName
            }}</span>
            <v-tooltip bottom v-if="course.courseName.length > 50">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  course.courseName.substring(0, 50) + "..."
                }}</span>
              </template>
              <span>{{ course.courseName }}</span>
            </v-tooltip>
          </v-card-title>

          <v-container class="pa-0 ma-1">
            <!-- Price Section (for Buyable courses without ClassRoom) -->
            <v-row
              class="ma-1 pa-0"
              v-if="course.buyable && !course.classRoomId && isRecommended"
            >
              <p class="pa-0 ma-0 text-h5">
                Price :
                <span class="primary--text text-h5 font-weight-medium"
                  >₹ {{ course.price }}</span
                >
              </p>
            </v-row>

            <!-- Progress Section -->
            <v-row
              class="ma-1"
              v-else-if="
                course.classProgressCompletion != null ||
                course.courseProgressCompletion != null
              "
            >
              <v-col cols="10" class="pa-0">
                <v-progress-linear
                  rounded
                  style="border-radius: 2.2rem"
                  height="20"
                  :value="
                    course.classProgressCompletion ||
                    course.courseProgressCompletion
                  "
                  color="success"
                ></v-progress-linear>
              </v-col>
              <v-col cols="2" class="pa-0 mt-2">
                <v-row justify="end">
                  <span style="font-size: 1.1rem; font-weight: 500"
                    >{{
                      course.classProgressCompletion ||
                      course.courseProgressCompletion
                    }}%</span
                  >
                </v-row>
              </v-col>
            </v-row>

            <!-- Yet to Start Section -->
            <v-row
              v-else-if="
                !course.buyable &&
                course.classProgressCompletion == null &&
                !isRecommended
              "
            >
              <v-chip medium class="error-chip" style="font-size: 1rem"
                >Yet to start!</v-chip
              >
            </v-row>

            <!-- Description Section -->
            <v-card-text class="pa-1">
              <div
                class="pa-0"
                style="font-size: 0.9rem"
                v-if="course.description && course.description.length < 160"
              >
                <span v-html="course.description"> </span>
              </div>
              <div
                class="pa-0"
                style="font-size: 0.9rem"
                v-if="
                  course.description &&
                  course.description.length >= 160 &&
                  !showFullDesc
                "
              >
                <span
                  v-html="course.description.substring(0, 160) + '...'"
                ></span>
                <v-row justify="center">
                  <v-btn
                    color="primary"
                    small
                    text
                    @click="showFullDesc = true"
                  >
                    Read more
                  </v-btn>
                </v-row>
              </div>
              <div
                class="pa-0 ma-1"
                style="font-size: 0.9rem"
                v-if="
                  course.description &&
                  course.description.length >= 160 &&
                  showFullDesc
                "
              >
                <span v-html="course.description"> </span>
                <v-row justify="center">
                  <v-btn
                    color="primary"
                    small
                    text
                    @click="showFullDesc = false"
                  >
                    Read less
                  </v-btn>
                </v-row>
              </div>
            </v-card-text>
          </v-container>
        </v-col>

        <!-- Actions & Type -->
        <v-col cols="end" class="d-flex flex-column justify-space-between">
          <v-row class="justify-center">
            <v-img
              class="mt-10"
              v-if="
                course.courseType == COURSE_TYPE_PRIVATE &&
                course.buyable == true
              "
              src="../assets/premium-quality 1.svg"
              max-height="30"
              max-width="30"
            ></v-img>
            <v-chip
              v-if="course.courseType == COURSE_TYPE_PUBLIC"
              class="error-chip mt-9"
            >
              FREE
            </v-chip>
          </v-row>

          <v-row class="justify-center">
            <v-btn
              v-if="course.buyable && isRecommended"
              class="font-weight-bold text-body-1"
              color="primary"
              @click="$emit('buy', course)"
            >
              Buy Now
            </v-btn>
            <v-btn
              v-else
              class="font-weight-bold text-body-1"
              color="primary"
              @click="$emit('open', course)"
            >
              {{ actionLabel }}
            </v-btn>
          </v-row>

          <v-row
            v-if="
              course.status == STATUS_REVIEW && course.studentReview == null
            "
            class="justify-center"
          >
            <v-btn
              class="font-weight-bold text-body-1 mt-4"
              color="primary-btn"
              @click="ReviewCourseConfirm(APPROVED)"
            >
              Approve
            </v-btn>
            <v-btn
              class="font-weight-bold text-body-1 mt-4 ml-4"
              color="primary-btn"
              @click="ReviewCourseConfirm(REJECTED)"
            >
              Reject
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <ConfirmDialog
      :dialog="reviewConfirmDialog"
      :subMessage1="'Are you sure you want to complete review'"
      :subMessage2="course.courseName"
      @close="closeReviewDailog()"
      @confirm="reviewCourse()"
    />
  </div>
</template>

<script>
import {
  COURSE_TYPE_PRIVATE,
  COURSE_TYPE_PUBLIC,
  STATUS_REVIEW,
  APPROVED,
  REJECTED,
} from "@/common/constants";
import { REVIEW_COURSE, BASE_URL } from "@/common/apiEndpoints.js";
import { COURSE_REVIEW_COMPLETED_SUCCESSFULLY } from "@/common/apiMessageConstant";
import { SET_API_SUCCESS, SET_OVERLAY_VALUE } from "@/store/mutations";
import { GET_TOKEN } from "@/store/getters";
import { mapGetters, mapMutations } from "vuex";
import { getAxiosOptions } from "@/common/utility";
import axios from "axios";
import ConfirmDialog from "@/components/ConfirmDialog.vue";

export default {
  name: "StudentCoursesTabs",
  components: { ConfirmDialog },
  props: {
    course: {
      type: Object,
      required: true,
    },
    isRecommended: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showFullDesc: false,
      reviewConfirmDialog: false,
      COURSE_TYPE_PRIVATE,
      COURSE_TYPE_PUBLIC,
      STATUS_REVIEW,
      reviewDecision: null,
      APPROVED,
      REJECTED,
    };
  },
  computed: {
    ...mapGetters({
      token: `schoolModule/${GET_TOKEN}`,
    }),
    actionLabel() {
      // Determine label based on progress and type
      if (
        (this.course.classProgressCompletion &&
          this.course.classProgressCompletion == 100) ||
        (this.course.courseProgressCompletion &&
          this.course.courseProgressCompletion == 100)
      ) {
        return "Open";
      }
      if (
        this.course.classProgressCompletion == 0 ||
        !this.course.courseProgressId
      ) {
        return "Start";
      }
      return "Resume";
    },
  },
  methods: {
    ...mapMutations({
      setApiSuccess: `schoolModule/${SET_API_SUCCESS}`,
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
    }),
    ReviewCourseConfirm(reviewDecision) {
      this.reviewConfirmDialog = true;
      this.reviewDecision = reviewDecision;
    },
    closeReviewDailog() {
      this.reviewConfirmDialog = false;
    },
    reviewCourse() {
      const url = REVIEW_COURSE;
      let payload = {};
      payload.courseId = this.course.courseId;
      payload.reviewDecision = this.reviewDecision;
      this.setOverlayValue(true);
      axios
        .post(url, payload, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.closeReviewDailog();
          this.setApiSuccess(COURSE_REVIEW_COMPLETED_SUCCESSFULLY);
          this.$emit("review-complete");
          this.setOverlayValue(false);
        })
        .catch((error) => {
          this.setOverlayValue(false);
          // error = error.errorMessage;
          this.closeReviewDailog();
        });
    },
  },
};
</script>
